// extracted by mini-css-extract-plugin
module.exports = {"root":"horizontalUl_root__8LnCF","li":"horizontalUl_li__v84V1"};